// extracted by mini-css-extract-plugin
export default {"layout":"NegotiationsView_layout__i7A1t","header":"NegotiationsView_header__18e6v","content":"NegotiationsView_content__IlDi7","search":"NegotiationsView_search__JkGli"};